export default "__VITE_ASSET__BR6LCiUK__"